import React from 'react';
import { Box } from '@mui/material';

const ESCAPE_RE = /[.*+?^${}()|[\]\\]/g;

/**
 * Suchbegriffe im Text hervorheben.
 *
 * Der Server liefert bewusst reinen Text plus die Begriffsliste – markiert wird
 * erst hier. So entsteht serverseitig kein Markup, das eingeschleust werden
 * könnte, und dasselbe Snippet lässt sich in verschiedenen Kontexten anders
 * darstellen.
 */
export function highlight(text, terms) {
  const value = text || '';
  const usable = (terms || []).filter(Boolean);
  if (!value || usable.length === 0) return value;

  const pattern = usable
    .slice()
    .sort((a, b) => b.length - a.length) // längster Begriff zuerst -> keine Teiltreffer
    .map((t) => t.replace(ESCAPE_RE, '\\$&'))
    .join('|');

  let re;
  try {
    re = new RegExp(`(${pattern})`, 'gi');
  } catch {
    return value; // defensiv: unbrauchbares Muster lieber unmarkiert zeigen
  }

  return value.split(re).map((part, i) => (
    // Bei split() mit Gruppe sind die ungeraden Indizes die Treffer.
    i % 2 === 1 ? (
      <Box
        key={i}
        component="mark"
        sx={{
          bgcolor: 'warning.light',
          color: 'inherit',
          px: 0.2,
          borderRadius: 0.5,
        }}
      >
        {part}
      </Box>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  ));
}

/** Datum kurz und deutsch: "12.03.2026, 14:05". */
export function formatDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}
